// EN is already included
import "moment/locale/de";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/it";
import "moment/locale/pt";
